<form [formGroup]="formGroup()" (ngSubmit)="searchClicked.emit()">
  <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
    <mat-expansion-panel-header>
      <mat-panel-title>Filtres</mat-panel-title>

      <mat-panel-description class="search-button-wrapper">
        <div>
          <button
            matFab
            type="button"
            matTooltip="Réinitialiser les filtres"
            (click)="onResetClick($event)"
            class="app-button"
          >
            <mat-icon class="reversed">delete_sweep</mat-icon>
          </button>
          <button
            matFab
            type="submit"
            matTooltip="Rechercher"
            (click)="onSearchClick($event)"
            class="app-button"
          >
            <mat-icon class="reversed">search</mat-icon>
          </button>
        </div>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <ng-content></ng-content>
  </mat-expansion-panel>
</form>
